import {actions as A} from '../../constants/actions';

const hideGlobalErrorMessage = () => {
  return (dispatch) => {
    dispatch({
      type: A.HIDE_GLOBAL_ERROR_MESSAGE,
    });
  }
};

export {hideGlobalErrorMessage}
